module.exports = __webpack_public_path__ + "fonts/opensans-semibold-webfont.33ffa900.eot";